import React from 'react';
import { Box, Card, CardContent, Skeleton } from '@mui/material';

/**
 * SkeletonLoader Component
 *
 * Displays loading skeleton for the dashboard while data is being fetched
 * Shows skeleton placeholders for overview metrics and charts
 */
const SkeletonLoader = () => (
  <Box sx={{ mt: 4, mb: 4, px: 2, width: '100%' }}>
    <Box mb={3}>
      <Skeleton variant="text" width={300} height={40} />
      <Skeleton variant="text" width={200} height={20} sx={{ mt: 1 }} />
    </Box>

    {/* Overview Metrics Skeleton */}
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        mb: 3,
        flexWrap: { xs: 'wrap', md: 'nowrap' },
        '& > *': {
          flex: '1 1 0',
          minWidth: 0,
        },
      }}
    >
      {[1, 2, 3, 4, 5].map(item => (
        <Card key={item} sx={{ height: 160 }}>
          <CardContent sx={{ height: '100%', position: 'relative' }}>
            <Skeleton
              variant="circular"
              width={40}
              height={40}
              sx={{ position: 'absolute', top: 16, right: 16 }}
            />
            <Box sx={{ pt: 5 }}>
              <Skeleton variant="text" width={80} height={40} />
              <Skeleton variant="text" width={120} height={24} sx={{ mt: 1 }} />
              <Skeleton
                variant="text"
                width={100}
                height={20}
                sx={{ mt: 0.5 }}
              />
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>

    {/* Charts Skeleton */}
    <Box sx={{ mb: 3 }}>
      <Skeleton variant="text" width={200} height={32} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" height={500} />
    </Box>
  </Box>
);

export default SkeletonLoader;
